import React from "react";
import { MultiSelect } from "react-multi-select-component";
import styles from "./DaySelector.module.scss";
import classnames from "classnames";
import { changeValueOfDay } from "utils/changeValueOfDay";
import { days } from "utils/constants";

const DaySelector = ({
  idRow,
  day,
  setSelectedDayOfWeek,
  selectedDayOfWeek = [],
  daysOptions,
  formErrors,
}) => {
  
  const handleClick = (e) => {
    const array = [];
    e?.map(({ label, value }) => {
      return array.push({
        label: label,
        value: value,
      });
    });
    changeValueOfDay(idRow, setSelectedDayOfWeek, array);
  };

  const schedulesValueRenderer = (selectedDayOfWeek) => {
    if (!selectedDayOfWeek?.length) {
      return null;
    } else if (selectedDayOfWeek?.length === 1) {
      return selectedDayOfWeek[0]?.value;
    } else {
      return `${selectedDayOfWeek.map((item) => item.value).join(", ")} `;
    }
  };
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      cursor: state.disabled ? "default" : "pointer",
      ":hover": {
        backgroundColor: state.disabled ? null : "#eee",
        cursor: state.disabled ? "default" : "pointer",
      },
    }),
  };
  return (
    <div className={styles.group}>
      <label htmlFor="team" className={styles.label}>
        Days
      </label>
      <MultiSelect
        className={classnames(
          styles.select,
          styles.select_middle,
          formErrors && styles.inputError,
        )}
        options={daysOptions || days}
        value={selectedDayOfWeek}
        valueRenderer={schedulesValueRenderer}
        onChange={handleClick}
        disableSearch={true}
        styles={customStyles}
      />
    </div>
  );
};

export default DaySelector;
